import {useState} from 'react';
import {findCompanyBrand} from '../lib/companyBrands';
import './CompanyMark.css';

/** Read-only first-party branding. Never a connection, entitlement or auth indicator. */
export default function CompanyMark({brandKey,name,compact=false}:{brandKey:string;name?:string;compact?:boolean}){
 const [failed,setFailed]=useState(false);
 const brand=findCompanyBrand(brandKey);
 const displayName=name||brand?.name||'Company';
 const artwork=brand?.asset&&!failed?brand.asset:null;
 return <span className={'ao-company-mark'+(compact?' compact':'')+(artwork?' has-image':' is-pending')}
   aria-hidden="true" title={brand?.assetKind==='placeholder'?'Official logo pending':displayName}>
   {artwork?<img src={artwork} loading="lazy" decoding="async"
     alt="" onError={()=>setFailed(true)}/>:
    <span className="ao-company-initial">{brand?.initial||displayName.trim().slice(0,1).toUpperCase()}</span>}
 </span>;
}
